<template>
    <rkm-area
        title="Paciente"
        type="fieldset"
    >
        <Form
            :form="form"
            :model="model"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>